module.exports = __webpack_public_path__ + "img/arrow-right.a5a24310.svg";